import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IStepTablesSearchParam,
  IStepTradeTableReport,
} from "../../../Interfaces/stepInterfaces";
import {
  getStepAggregatedTradeTable
} from "../../../Requests/stepRequests";
import { CommonTableUI } from "../../TableTemplate/common";

interface TradeTableProps {
  searchParam: IStepTablesSearchParam;
}

const StepAggregateTradeTable = ({ searchParam }: TradeTableProps) => {
  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table">
      <TableTemplate<IStepTablesSearchParam, IStepTradeTableReport>
        refreshTableTime={5000}
        getDataTable={(searchParam, offset, pageSize, sortingType) =>
          getStepAggregatedTradeTable(
            searchParam,
            offset,
            pageSize,
            sortingType || ""
          )
        }
        withSort
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
          />
        )}
        searchParameters={searchParam}
      />
    </div>
  );
};

export default StepAggregateTradeTable;
